import React, { useEffect, useState, useRef } from "react";
import FormModal from "../FormModal";
import {
  Image,
  Space,
  Radio,
  Message,
  Spin,
  Checkbox,
  Pagination,
  Tag,
} from "@arco-design/web-react";
type Props = {
  visible: boolean;
  handCancel?: () => void;
  submitHandle?: (obj: any) => void;
  fileType: string;
  isCloud?: boolean; //是不是云剪
  cloudImags?: any[];
};
import avtiveImg from "@/assets/create-space/project-modal-icon.png";
import "./ChooseTemplate.less";
import usePagination from "../hooks/usePagination";
import {
  getFusionmediafolderApi,
  fusionmediaTemplateApi,
} from "@/services/quickcut";
import fileIcon from "@/assets/quick-img/file-icon.png";
import noData from "@/assets/quick-img/no-data-min.png";
import QuickCutStore from "@/stores/quickCutStore";
import { log } from "console";
const ChooseTemplateModal = (props: Props) => {
  const { visible, handCancel, submitHandle, fileType } = props;
  const [uploadVisible, setUploadVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [folder_id, setFolder_id] = useState(null);
  const [folderName, setFolderName] = useState(null);
  const [images, setImages] = useState<any[]>([]);
  const [chooseObj, setChooseObj] = useState<any>(null);
  const [imgVisible, setImgVisible] = useState(false);
  const [url, setUrl] = useState("");
  const [imgLoading, setImgLoading] = useState(false);
  const [imgPage, setImgPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const [selectAll, setSelectAll] = useState(false);
  const imgBoxRef = useRef<HTMLDivElement>(null);
  const hasAppliedSelectionRef = useRef<boolean>(false);

  // 根据 Store 选中状态对 images 进行回显
  const applyStoreSelection = (imgs: any[]) => {
    const isVideo = fileType === "3";
    const storeList = isVideo
      ? QuickCutStore.quickcutData.settings.video_template || []
      : QuickCutStore.quickcutData.settings.cover_template || [];
    const idSet = new Set(storeList.map((i: any) => i.id));
    return (imgs || []).map((img: any) => ({
      ...img,
      check: idSet.has(img.id),
    }));
  };

  // 计算“已选中的总数”（Store + settings 的去重并集）
  const getSelectedTotal = () => {
    const isVideo = fileType === "3";
    const storeList = isVideo
      ? QuickCutStore.videoTemplates || []
      : QuickCutStore.coverTemplates || [];
    const settingsList = isVideo
      ? QuickCutStore.quickcutData?.settings?.video_template || []
      : QuickCutStore.quickcutData?.settings?.cover_template || [];
    const idSet = new Set<number>();
    settingsList.forEach((i: any) => {
      if (i?.id != null) idSet.add(i.id);
    });
    storeList.forEach((i: any) => {
      if (i?.id != null) idSet.add(i.id);
    });
    return idSet.size;
  };

  // 获取“已选中的具体列表”（Store + settings 的去重并集）
  const getUnionSelectedList = () => {
    const isVideo = fileType === "3";
    const storeList = isVideo
      ? QuickCutStore.videoTemplates || []
      : QuickCutStore.coverTemplates || [];
    const settingsList = isVideo
      ? QuickCutStore.quickcutData?.settings?.video_template || []
      : QuickCutStore.quickcutData?.settings?.cover_template || [];
    const map = new Map<number, any>();
    settingsList.forEach((i: any) => {
      if (i?.id != null) map.set(i.id, { ...i, check: true });
    });
    storeList.forEach((i: any) => {
      if (i?.id != null) map.set(i.id, { ...i, check: true });
    });
    return Array.from(map.values());
  };

  // 弹框打开时：将 settings 里的预选与 Store 合并（去重），并仅回显一次（当首次拿到 images 数据时）
  useEffect(() => {
    if (visible) {
      // 合并 settings 预选到 Store，确保提交时包含回显
      const isVideo = fileType === "3";
      const settingsList = isVideo
        ? QuickCutStore.quickcutData?.settings?.video_template || []
        : QuickCutStore.quickcutData?.settings?.cover_template || [];

      if (isVideo) {
        const map = new Map<number, any>();
        (QuickCutStore.videoTemplates || []).forEach((i: any) => {
          if (i?.id != null) map.set(i.id, i);
        });
        (settingsList || []).forEach((i: any) => {
          if (i?.id != null && !map.has(i.id))
            map.set(i.id, { ...i, check: true });
        });
        QuickCutStore.videoTemplates = Array.from(map.values());
      } else if (fileType === "1") {
        const map = new Map<number, any>();
        (QuickCutStore.coverTemplates || []).forEach((i: any) => {
          if (i?.id != null) map.set(i.id, i);
        });
        (settingsList || []).forEach((i: any) => {
          if (i?.id != null && !map.has(i.id))
            map.set(i.id, { ...i, check: true });
        });
        QuickCutStore.coverTemplates = Array.from(map.values());
      }

      hasAppliedSelectionRef.current = false;
    }
  }, [visible]);

  useEffect(() => {
    if (
      visible &&
      !hasAppliedSelectionRef.current &&
      images &&
      images.length > 0
    ) {
      const reflected = applyStoreSelection(images);
      hasAppliedSelectionRef.current = true;
      setImages(reflected);
    }
  }, [visible, images]);

  // 监听images变化，更新全选状态
  useEffect(() => {
    if (images.length > 0) {
      const allChecked = images.every((img) => img.check);
      setSelectAll(allChecked);
    } else {
      setSelectAll(false);
    }
  }, [images]);
  const { settings } = props.isCloud
    ? {
        settings: {
          [props.fileType === "1" ? "cover_template" : "video_template"]:
            props.cloudImags,
        },
      }
    : QuickCutStore.quickcutData;
  const submit = () => {
    const unionList = getUnionSelectedList();
    if ((unionList?.length || 0) === 0) {
      Message.warning("请至少选择一个模板");
      return;
    }
    const data = (unionList || []).slice(0, 100);
    submitHandle(data);
  };
  useEffect(() => {
    if (visible) {
      refresh();
    } else {
      setFolder_id(null);
    }
  }, [visible, fileType]);
  const {
    data: tableData,
    loading,
    pagination,
    onSearch,
    params,
    setParams,
    refresh,
  } = usePagination({
    fetchData: async (params) => {
      const res = await getFusionmediafolderApi({
        ...params,
        parent_id: 0,
        type: fileType,
      }); // 关键：传递额外参数
      return {
        list: (res?.data?.list || [])?.map((item: any, idx: number) => ({
          ...item,
          key: item.id || idx,
        })),
        total: res?.data?.total || 0,
      };
    },
    defaultParams: {},
    defaultPagination: { page_num: 1, page_size: 30 },
  });

  const getImgs = async (page = 1, append = false) => {
    setImgLoading(true);
    try {
      const res = await fusionmediaTemplateApi({
        folder_id: Number(folder_id),
        page_num: page,
        page_size: 30,
      });

      // 获取当前类型下已选中的模板ID
      const selectedTemplates =
        fileType === "3"
          ? QuickCutStore.videoTemplates || []
          : fileType === "1"
            ? QuickCutStore.coverTemplates || []
            : [];

      const selectedIds = new Set(
        selectedTemplates.map((item: any) => item.id)
      );

      // 处理返回的数据，设置选中状态
      const updatedImages =
        res.data.list?.map((item: any) => ({
          ...item,
          check: selectedIds.has(item.id), // 如果模板ID在已选列表中，则设置为选中状态
        })) || [];

      // 合并/覆盖列表
      if (append) {
        setImages((prev) => {
          // 简单追加，假设接口不会返回重复 id
          const merged = [...prev, ...updatedImages];
          return merged;
        });
      } else {
        setImages(updatedImages);
      }

      // 更新全选状态
      if (updatedImages.length > 0) {
        const allChecked = updatedImages.every((img: any) => img.check);
        setSelectAll(allChecked);
      } else {
        setSelectAll(false);
      }

      setHasMore((res.data?.list?.length || 0) === 30); // 如果返回数量等于page_size，说明可能还有下一页
    } catch (error) {
      console.error("获取模板列表失败:", error);
      Message.error("获取模板列表失败");
    } finally {
      setImgLoading(false);
    }
  };

  useEffect(() => {
    setImgPage(1);
    setHasMore(true);
    // 切换文件夹时清空已有数据，避免残留
    setImages([]);
    getImgs(1, false);
  }, [folder_id]);

  // IntersectionObserver 触底加载
  useEffect(() => {
    if (!folder_id) return;
    const rootEl = imgBoxRef.current || null;
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !imgLoading && hasMore) {
          const nextPage = imgPage + 1;
          setImgPage(nextPage);
          getImgs(nextPage, true);
        }
      },
      { root: rootEl, rootMargin: "0px", threshold: 0.1 }
    );
    const target = loadMoreRef.current;
    if (target) {
      observer.observe(target);
    }
    return () => {
      if (target) {
        observer.unobserve(target);
      }
      observer.disconnect();
    };
  }, [imgLoading, hasMore, imgPage, folder_id]);

  const showFlagFun = (arr) => {
    let flag = false;
    if (arr?.length > 0) {
      arr.forEach((item) => {
        if (item?.Type === "SubTitle" || item.Type === "Subtitle") {
          // 检查任一字幕片段是否有Width问题
          const hasWidthIssue = item.VideoTrackClips.some((clip) => {
            return !clip?.Width || clip?.Width > clip.TextWidth;
          });
          // 如果有任何一个轨道有问题，就设置为异常
          if (hasWidthIssue) {
            flag = true;
          }
        }
      });
    }
    return flag;
  };

  return (
    <div>
      <FormModal
        subTitle={`${fileType === "3" ? `确定(已选择${QuickCutStore.videoTemplates?.length || 0}个模板)` : `确定(已选择${QuickCutStore.coverTemplates?.length || 0}个模板)`}`}
        style={{ width: 1060, top: 50 }}
        icon={avtiveImg}
        width={700}
        title={"模板选择"}
        visible={visible}
        submitHandle={() => {
          submit();
        }}
        handCancel={() => {
          QuickCutStore.videoTemplates = [];
          QuickCutStore.coverTemplates = [];
          handCancel();
        }}
      >
        <div
          className={"template-box1"}
          style={{
            padding: 20,
            height: 650,
            overflowY: "auto",
            paddingBottom: 40,
          }}
        >
          {folder_id && (
            <div style={{ marginBottom: 20 }}>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setFolder_id(null);
                  setSelectedIndex(null);
                  refresh();
                }}
              >
                {folderName}
              </span>{" "}
              / 模板
              <Checkbox
                style={{ marginLeft: 5 }}
                checked={selectAll}
                onChange={(checked) => {
                  setSelectAll(checked);
                  if (checked) {
                    // 受限全选：仅在不超过100的前提下选中当前页尽可能多的模板（并集：Store + settings）
                    const currentPageIds = new Set(images.map((img) => img.id));
                    const isVideo = fileType === "3";
                    const storeList = isVideo
                      ? QuickCutStore.videoTemplates || []
                      : QuickCutStore.coverTemplates || [];
                    const settingsList = isVideo
                      ? QuickCutStore.quickcutData?.settings?.video_template ||
                        []
                      : QuickCutStore.quickcutData?.settings?.cover_template ||
                        [];
                    const unionSelectedIds = new Set<number>();
                    settingsList.forEach((i: any) => {
                      if (i?.id != null) unionSelectedIds.add(i.id);
                    });
                    storeList.forEach((i: any) => {
                      if (i?.id != null) unionSelectedIds.add(i.id);
                    });

                    // 其他页已选数量（不包含当前页）
                    let otherSelectedCount = 0;
                    unionSelectedIds.forEach((id) => {
                      if (!currentPageIds.has(id)) otherSelectedCount++;
                    });

                    const alreadyCheckedOnPage = images.filter(
                      (img) => img.check
                    );
                    const notCheckedOnPage = images.filter((img) => !img.check);
                    const remaining = Math.max(0, 100 - otherSelectedCount);
                    const canPickCount = Math.max(
                      0,
                      remaining - alreadyCheckedOnPage.length
                    );

                    const pickedSet = new Set<number>();
                    if (canPickCount > 0) {
                      notCheckedOnPage
                        .slice(0, canPickCount)
                        .forEach((img) => pickedSet.add(img.id));
                    }

                    const updatedImages = images.map((img) => ({
                      ...img,
                      check: img.check || pickedSet.has(img.id),
                    }));

                    // 更新Store，保留其他页已选中的模板 + 本页选中的（以 Store 为最终来源）
                    const updatedCheckedOnPage = updatedImages.filter(
                      (img) => img.check
                    );
                    if (isVideo) {
                      // 重新构造“其他已选（不含本页）”来自 Store
                      const otherFromStore = (
                        QuickCutStore.videoTemplates || []
                      ).filter((it: any) => !currentPageIds.has(it.id));
                      QuickCutStore.videoTemplates = [
                        ...otherFromStore,
                        ...updatedCheckedOnPage,
                      ];
                    } else if (fileType === "1") {
                      const otherFromStore = (
                        QuickCutStore.coverTemplates || []
                      ).filter((it: any) => !currentPageIds.has(it.id));
                      QuickCutStore.coverTemplates = [
                        ...otherFromStore,
                        ...updatedCheckedOnPage,
                      ];
                    }

                    // 使用本地更新结果回写
                    setImages(updatedImages);

                    // 如果无法把本页全部选中，给出提示
                    const couldNotSelectAll = updatedImages.some(
                      (img) => !img.check
                    );
                    if (
                      couldNotSelectAll &&
                      notCheckedOnPage.length > pickedSet.size
                    ) {
                      Message.warning("最多选择100个模板，已为你选择可用数量");
                    }

                    // 根据结果重新设置全选状态
                    const allChecked =
                      updatedImages.length > 0 &&
                      updatedImages.every((img) => img.check);
                    setSelectAll(allChecked);
                  } else {
                    // 取消全选当前页
                    const updatedImages = images.map((img) => ({
                      ...img,
                      check: false,
                    }));

                    // 从Store中移除当前页的选中项
                    const currentPageIds = new Set(
                      updatedImages.map((img) => img.id)
                    );
                    if (fileType === "3") {
                      QuickCutStore.videoTemplates = (
                        QuickCutStore.videoTemplates || []
                      ).filter((item) => !currentPageIds.has(item.id));
                    } else if (fileType === "1") {
                      QuickCutStore.coverTemplates = (
                        QuickCutStore.coverTemplates || []
                      ).filter((item) => !currentPageIds.has(item.id));
                    }

                    // 使用本地更新结果回写（此时本页应均未选）
                    setImages(updatedImages);
                  }
                }}
              >
                <span style={{ fontSize: 12 }}>
                  全选 ({getSelectedTotal()} / 100)
                </span>
              </Checkbox>
            </div>
          )}
          {!folder_id && (
            <div className={"template-list"}>
              {tableData?.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      setFolder_id(item.id);
                      setFolderName(item.name);
                    }}
                    key={index}
                    className={"template-item"}
                  >
                    <img
                      style={{ width: 50, height: 50 }}
                      src={fileIcon}
                      alt=""
                    />
                    <div className={"template-title"}>{item.name}</div>
                  </div>
                );
              })}
              {loading && <Spin className={"template-spin"} />}
            </div>
          )}
          {folder_id && (
            <div
              ref={imgBoxRef}
              className={"img-box"}
              style={{ maxHeight: 650, overflow: "auto" }}
            >
              {images?.map((item, index) => {
                return (
                  <div
                    className={"img-item"}
                    onClick={() => {
                      setUrl(item?.cover_url || item?.cover);
                      setImgVisible(true);
                    }}
                    key={index}
                    style={{ position: "relative", display: "block" }}
                  >
                    <div className={"img-cover"}>
                      <img
                        style={{
                          objectFit: "scale-down",
                          width: 95,
                          height: 100,
                        }}
                        src={item.cover_url || item?.cover}
                      />
                    </div>
                    <div className={"img-info"}>{item.name}</div>
                    <div className={"select-check"}>
                      <Checkbox
                        checked={item.check}
                        onChange={(checked) => {
                          // 单选校验：限制最多100个
                          const isVideo = fileType === "3";
                          if (
                            checked &&
                            !item.check &&
                            getSelectedTotal() >= 100
                          ) {
                            Message.warning("最多选择100个模板");
                            return;
                          }

                          // 更新当前页面的选中状态（先本地，后用 Store 回显）
                          const updatedImages = images.map((img) =>
                            img.id === item.id
                              ? { ...img, check: checked }
                              : img
                          );

                          // 更新Store中的数据
                          if (isVideo) {
                            if (checked) {
                              // 添加到已选列表
                              QuickCutStore.videoTemplates = [
                                ...(QuickCutStore.videoTemplates || []).filter(
                                  (i) => i.id !== item.id
                                ),
                                { ...item, check: true },
                              ];
                            } else {
                              // 从已选列表中移除
                              QuickCutStore.videoTemplates = (
                                QuickCutStore.videoTemplates || []
                              ).filter((i) => i.id !== item.id);
                            }
                          } else if (fileType === "1") {
                            if (checked) {
                              // 添加到已选列表
                              QuickCutStore.coverTemplates = [
                                ...(QuickCutStore.coverTemplates || []).filter(
                                  (i) => i.id !== item.id
                                ),
                                { ...item, check: true },
                              ];
                            } else {
                              // 从已选列表中移除
                              QuickCutStore.coverTemplates = (
                                QuickCutStore.coverTemplates || []
                              ).filter((i) => i.id !== item.id);
                            }
                          }

                          // 使用本地更新结果回写
                          setImages(updatedImages);

                          // 同步全选状态
                          const allChecked =
                            updatedImages.length > 0 &&
                            updatedImages.every((img) => img.check);
                          setSelectAll(allChecked);
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                );
              })}
              {imgLoading && <Spin className={"template-spin"} />}
              <div ref={loadMoreRef} style={{ height: 1 }} />
            </div>
          )}
          {(tableData?.length === 0 || images.length === 0) && folder_id && (
            <div className={"no-data"}>
              <img src={noData} alt="" />
              <div className={"data-info "}>暂无数据</div>
            </div>
          )}
          {!folder_id && (
            <div className={"base-page-pagination"}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.page_size}
                total={pagination.total}
                onChange={pagination.onChange}
                showTotal
                sizeCanChange
              />
            </div>
          )}
        </div>
        <FormModal
          showFooter={false}
          handCancel={() => {
            setImgVisible(false);
          }}
          visible={imgVisible}
          title={"预览"}
        >
          <img
            src={url}
            style={{
              width: 360,
              height: 640,
              margin: "10px auto",
              display: "block",
            }}
            alt=""
          />
        </FormModal>
      </FormModal>
    </div>
  );
};
export default ChooseTemplateModal;
